import { observer } from 'mobx-react'
import styles from './BuyPopup.module.less'
import { Popup } from 'antd-mobile'
import classNames from 'classnames'
import wechatpay from '@/assets/images/wechat-pay.png'
import alipay from '@/assets/images/ali-pay.png'
import close from '@/assets/images/close.png'
import { useEffect, useState } from 'react'
import { api } from '@/helpers/api'
import { commonUtils } from '@/helpers/commonUtils'
import { userService } from '@/services/userService/userService'
import { payService } from '@/services/payService'
import { CheckCircleFill } from 'antd-mobile-icons'
export interface BuyPopupProps {
  goodsId?: string
  goodsType?: DataModels.goods.GoodsType
  visible: boolean
  onClose?: () => void
  onDownload?: () => void
  onPaySuccess?: () => void
}

let isPaying = false
const BuyPopup = observer((props: BuyPopupProps) => {
  const [checked, setChecked] = useState(1)
  const [chargeChannel, setChargeChannel] = useState<'wx_pub_qr' | 'alipay_qr'>('wx_pub_qr')
  const [priceInfo, setPriceInfo] = useState<DataModels.goods.CourseMaterialPriceInfo[]>([])

  useEffect(() => {
    const initPlanData = async () => {
      if (!props.goodsId || !props.goodsType) return
      const { data } = await api.goods.getCourseMaterialPriceInfo(props.goodsId, props.goodsType)
      setPriceInfo(data)
      setChecked(data.length)
    }
    initPlanData()
  }, [props.goodsId, props.goodsType])

  const parseCurrency = (price?: number) => {
    if (typeof price === 'number') {
      return commonUtils.parseCurrency(price)
    }
    return '-'
  }

  const doPay = async () => {
    if (isPaying) {
      return
    }
    userService.postUserActionRecord({
      module: '移动端官网',
      function: '付费弹窗',
      position: '付费弹窗点击购买按钮',
      action: '点击',
      element: '按钮',
    })
    isPaying = true
    await payService.createH5Pay({
      goodsId: priceInfo[checked - 1]?.goodsId,
      goodsType: priceInfo[checked - 1]?.goodsType,
      chargeChannel,
      onPaySuccess: () => {
        props.onClose?.()
        props.onPaySuccess?.()
      },
    })
    isPaying = false
  }

  const onClose = () => {
    props.onClose?.()
  }

  return (
    <Popup
      visible={props.visible}
      onMaskClick={onClose}
      bodyStyle={{
        borderTopLeftRadius: '20px',
        borderTopRightRadius: '20px',
      }}
    >
      <div className={styles.buyPopup}>
        <div className={styles.buyPopupHeader}>
          <div>下载课程及教案</div>
          <div onClick={onClose} className={styles.buyPopupHeaderClose}>
            <img src={close} draggable={false} />
          </div>
        </div>
        <div className={styles.buyPopupContent}>
          <div className={styles.buyPopupUser}>
            <div className={styles.infoBox}>
              <div className={styles.infoBoxLabel}>账号：</div>
              <div className={styles.infoBoxVal}>{userService.userId}</div>
            </div>
          </div>
          <div className={styles.buyPopupCourse}>
            <div
              className={classNames(styles.goodsBox, {
                [styles.checked]: checked === 1,
              })}
              onClick={() => setChecked(1)}
            >
              <div className={styles.goodsBoxTitle}>单课件</div>
              <div className={styles.goodsBoxGift}>
                <span>
                  <img src={commonUtils.getStaticFile('pay/1.png')} alt='pay/1' /> 赠送配套教案
                </span>
              </div>
              <div className={styles.goodsBoxPrice}>
                <span className={styles.unit}>￥</span>
                {parseCurrency(priceInfo[0]?.goodsPrice)}
              </div>
            </div>
            {priceInfo.length > 1 && (
              <div
                className={classNames(styles.goodsBox, styles.volume, {
                  [styles.checked]: checked === 2,
                })}
                onClick={() => setChecked(2)}
              >
                <div className={styles.goodsBoxTitle}>{priceInfo[1]?.goodsName}</div>
                <div className={styles.goodsBoxGift}>
                  <span>
                    <img src={commonUtils.getStaticFile('pay/2.png')} alt='pay/2' /> 包含
                    <span className={styles.highlight}>{priceInfo[1]?.couresCount}</span>
                    套精编课件
                  </span>
                  <span>
                    <img src={commonUtils.getStaticFile('pay/2.png')} alt='pay/2' />
                    赠送全套教学设计
                  </span>
                  <span>
                    <img src={commonUtils.getStaticFile('pay/2.png')} alt='pay/2' />
                    赠送单元复习/期中/期末复习课件
                  </span>
                </div>
                <div className={styles.goodsBoxPrice}>
                  <span className={styles.unit}>￥</span>
                  {parseCurrency(priceInfo[1]?.goodsPrice)}
                  <div className={styles.onePrice}>
                    单课件仅需
                    <span className={styles.highlight}>
                      {parseCurrency(priceInfo[1]?.onePrice)}
                    </span>
                    元
                  </div>
                </div>
              </div>
            )}
            {priceInfo.length > 2 && (
              <div
                className={classNames(styles.goodsBox, styles.grade, {
                  [styles.checked]: checked === 3,
                })}
                onClick={() => setChecked(3)}
              >
                <div className={styles.goodsBoxTitle}>{priceInfo[2]?.goodsName}</div>
                <div className={styles.goodsBoxGift}>
                  <span>
                    <img src={commonUtils.getStaticFile('pay/3.png')} alt='pay/3' /> 包含
                    <span className={styles.highlight}>{priceInfo[2]?.couresCount}</span>
                    套课件
                  </span>
                  <span>
                    <img src={commonUtils.getStaticFile('pay/3.png')} alt='pay/2' />
                    赠送全套教学设计
                  </span>
                  <span>
                    <img src={commonUtils.getStaticFile('pay/3.png')} alt='pay/3' />
                    赠送单元复习课件
                  </span>
                  <span>
                    <img src={commonUtils.getStaticFile('pay/3.png')} alt='pay/3' />
                    赠送期中/期末复习课件
                  </span>
                  <span>
                    <img src={commonUtils.getStaticFile('pay/3.png')} alt='pay/3' /> 赠送教辅资料
                  </span>
                  <span>
                    <img src={commonUtils.getStaticFile('pay/3.png')} alt='pay/3' />
                    专属人工客服答疑
                  </span>
                </div>
                <div className={styles.goodsBoxPrice}>
                  <span className={styles.unit}>￥</span>
                  {parseCurrency(priceInfo[2]?.goodsPrice)}
                  <div className={styles.onePrice}>
                    单课件仅需
                    <span className={styles.highlight}>
                      {parseCurrency(priceInfo[2]?.onePrice)}
                    </span>
                    元
                  </div>
                </div>
              </div>
            )}
            {priceInfo.length > 3 && (
              <div
                className={classNames(styles.goodsBox, styles.schoolSection, {
                  [styles.checked]: checked === 4,
                })}
                onClick={() => setChecked(4)}
              >
                <div className={styles.goodsBoxTitle}>{priceInfo[3]?.goodsName}</div>
                <div className={styles.goodsBoxGift}>
                  <span>
                    <img src={commonUtils.getStaticFile('pay/2.png')} alt='pay/3' /> 包含
                    <span className={styles.highlight}>{priceInfo[3]?.couresCount}</span>
                    套课件
                  </span>
                  <span>
                    <img src={commonUtils.getStaticFile('pay/2.png')} alt='pay/2' />
                    赠送全套教学设计
                  </span>
                  <span>
                    <img src={commonUtils.getStaticFile('pay/2.png')} alt='pay/3' />
                    赠送单元复习课件
                  </span>
                  <span>
                    <img src={commonUtils.getStaticFile('pay/2.png')} alt='pay/3' />
                    赠送期中/期末复习课件
                  </span>
                  <span>
                    <img src={commonUtils.getStaticFile('pay/2.png')} alt='pay/3' /> 赠送教辅资料
                  </span>
                  <span>
                    <img src={commonUtils.getStaticFile('pay/2.png')} alt='pay/3' />
                    专属人工客服答疑
                  </span>
                </div>
                <div className={styles.goodsBoxPrice}>
                  <span className={styles.unit}>￥</span>
                  {parseCurrency(priceInfo[3]?.goodsPrice)}
                  <div className={styles.onePrice}>
                    单课件仅需
                    <span className={styles.highlight}>
                      {parseCurrency(priceInfo[3]?.onePrice)}
                    </span>
                    元
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className={classNames(styles.infoBox, styles.payItemBox)}>
            <div
              className={classNames(styles.payTypeItem)}
              onClick={() => setChargeChannel('wx_pub_qr')}
            >
              <div>
                <img className={styles.icon} src={wechatpay} />
                微信支付
              </div>
              {chargeChannel === 'wx_pub_qr' ? (
                <CheckCircleFill className={styles.checkIcon} color='#FF7006' />
              ) : (
                <div className={styles.checkIcon1} />
              )}
            </div>
            {!commonUtils.isWechat() && (
              <div
                className={classNames(styles.payTypeItem)}
                onClick={() => setChargeChannel('alipay_qr')}
              >
                <div>
                  <img className={styles.icon} src={alipay} />
                  支付宝支付
                </div>
                {chargeChannel === 'alipay_qr' ? (
                  <CheckCircleFill className={styles.checkIcon} color='#FF7006' />
                ) : (
                  <div className={styles.checkIcon1} />
                )}
              </div>
            )}
          </div>
        </div>
        <div className={styles.buyPopupFooter}>
          <div className={styles.buyPopupFooterLeft}>
            <div className={styles.payBarLeftLabel}>应付：</div>
            <div className={styles.payBarLeftVal}>
              <span>￥</span>
              {parseCurrency(priceInfo[checked - 1]?.goodsPrice)}
            </div>
          </div>
          <div
            className={styles.payBtn}
            onClick={() => {
              // 购买
              doPay()
            }}
          >
            购买
          </div>
        </div>
      </div>
    </Popup>
  )
})

export default BuyPopup
